
import {
  Card,
  Spacer,
  Text
} from '@components/1-atoms';

import {
  AuthTemplate
} from '@components/4-templates';

import PayBooks from '@assets/paybooks';
import Illustration from '@assets/otp-illustration';

import {
  Button, Info, Input,
} from '@components/2-molecules';


import Locker from '@assets/icons/lock';

import React, { FC } from 'react';
import { STATE } from '@lib/constants';
import { useOtp, } from '@lib/hooks/base/useAuth';
import { setAuth } from '@lib/service';
import * as utils from '@lib/utils';
import { ForwardedPageProps } from '@lib/constants';

import { withForwardedNavigationParams } from 'react-navigation-props-mapper';

//@ts-ignore
const ConfirmOtp: FC<ForwardedPageProps> = ({ navigation, data = {}, ...props }) => {

  const [otp, setOtp] = useOtp({ operation: 'POST', state: STATE.CANCEL, data: data, });

  const confirmOTP = (): void => setOtp({ ...otp, state: STATE.READY, message: 'Confirming...' });
  utils.onStateChange(  otp, STATE.DONE, (data:any) =>  setAuth(data));

  const updateOTP = (data: any): void => setOtp((otp: any) => ({ ...otp, data: { ...otp.data, ...data } }));

  return (
    <AuthTemplate noPadding={true} hooks={[otp]}>

      <Spacer h={1} /><PayBooks /><Spacer h={2} />
      <Illustration />
      <Spacer h={4} />

      <Text large color="#FFF">We’ve sent your OTP to your email</Text>

      <Spacer h={9} />

      <Card>
        <Spacer h={3} />
        <Text large color="#000">Provide OTP to continue</Text>
        <Spacer h={2} />

        <Input
          onChange={(value) => { updateOTP({ otp: value }) }}
          onSubmitEditing={confirmOTP}
          left={<Locker />}
        />
        <Spacer h={2} />

        <Button inset onPress={confirmOTP}>CONFIRM</Button>
        <Spacer h={1} />

        <Info>Please check email box</Info>
        <Spacer h={1} />

        <Button
          onPress={() => {navigation.navigate("EmailLogin", {data: data})}}
          color={"#434BFF"}
          bg={"transparent"}>RESEND EMAIL</Button>
      </Card>
      <Spacer h={1} />

    </AuthTemplate>
  );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(ConfirmOtp);